module.exports = __webpack_public_path__ + "static/media/REGISTRO DE ACTIVOS DE LA INFORMACION NOTARIA.552a9555.pdf";